import create from "zustand";

interface DiscountState {
    loading: boolean;
    setLoading: (loading: boolean) => void;

    discount: any;
    setDiscount: (discount: any) => void;

    displayAboPriceBefore: number;

    aboPriceBefore: number;
    setAboPriceBefore: (s: number) => void;

    showMonthlyPrice: boolean;
    setShowMonthlyPrice: (s: boolean) => void;
}

const useDiscountState = create<DiscountState>(
    (set, get) => (
        {
            loading: false,
            setLoading: (loading) => set( { loading } ),

            discount: null,
            setDiscount: (discount) => {

                set( s => ({ discount } ) );

                if (discount?.productPriceBefore > 0) {
                    set(s => ({ displayAboPriceBefore: discount.productPriceBefore }));
                } else {
                    set(s => ({ displayAboPriceBefore: s.aboPriceBefore }));
                }

            },

            displayAboPriceBefore: null,

            aboPriceBefore: null,
            setAboPriceBefore: (aboPriceBefore) => {
                const displayAboPriceBefore = get().displayAboPriceBefore;
                set( s => ({ aboPriceBefore }));

                if (!displayAboPriceBefore) {
                    set(s => ({ displayAboPriceBefore: aboPriceBefore }));
                }
            },

            showMonthlyPrice: false,
            setShowMonthlyPrice:(showMonthlyPrice) => set( { showMonthlyPrice } ),
        }
    )
);

export default useDiscountState;
